import React, { useEffect, useMemo, useState } from "react";
import { PositionType } from "../types/data_types";
import {
  BhpHotKeysType,
  BhpSearchButton,
  BusinessDetailsType,
  ColorThemeInterface,
  StyleDataType,
} from "../pages/BussinessHomePage";
import {
  useAppSelector,
  useRecordUserInteractions,
  useSaveVcard,
  userActionsTable,
} from "../app/hooks";
import { getSessionDetails } from "../common/cookies";
import {
  convertImgJsonToObj,
  getLogo,
  goToGoogleMapsNav,
} from "../common/commonFunctions";
import { useHistory } from "react-router";
import {
  API_SECURE_KEY,
  IDIGIZEN_BACKEND_URL,
  bhpEditLinks,
  getFileThumbnailDB,
  getPageType,
  whatsappMessage,
} from "../types/constants";
import {
  IonButton,
  IonCol,
  IonGrid,
  IonHeader,
  IonIcon,
  IonRow,
} from "@ionic/react";
import {
  business,
  checkbox,
  checkmarkCircle,
  ellipse,
  ellipseOutline,
  menuOutline,
  menuSharp,
  navigateSharp,
  pencil,
  qrCodeOutline,
  search,
} from "ionicons/icons";
import { mobileWidthBreakpoint } from "../types/form_table_data_types";
import BhpCategoryCard from "./BhpCategoryCard";
import { getType } from "@reduxjs/toolkit";

const BhpSearchIconButton: React.FC<{
  onClick: () => void;
  styleData?: StyleDataType;
  icon?: any;
}> = (props) => {
  return (
    <div
      style={{
        height: "30px",
        width: "30px",
        // borderRadius: "50%",
        background: "none",
        // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        // border: props.styleData.headerBaseColor,
        // color: "#e4e1b8",
        color: props.styleData.headerBaseColorHighlight,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "22px",
        overflow: "hidden",
        flexDirection: "column",
        flexShrink: 0,
      }}
      onClick={props.onClick}
    >
      {/* {userDetails.id && userDetails.name.length
                ? userDetails.name[0]
                : "G"} */}
      <IonIcon icon={!!props?.icon ? props.icon : search} />
    </div>
  );
};

const BhpMenuButton: React.FC<{
  popoverId: string;
  onClick: () => void;
  styleData?: StyleDataType;
  noBg?: boolean;
}> = (props) => {
  return (
    <div
      style={{
        height: "30px",
        width: "30px",
        borderRadius: "50%",
        // background: "var(--ion-color-bhp-footer)",
        // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        // border:
        //   !!props?.styleId && !props?.noBg
        //     ? "1px solid var(--ion-color-bhp-hdr-yellow)"
        //     : undefined,
        // color: "#e4e1b8",
        color: props?.styleData.headerBaseColorHighlight,
        // background:
        //   !props?.styleId || props?.noBg
        //     ? undefined
        //     : "var(--ion-color-bhp-hdr-yellow)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "18px",
        overflow: "hidden",
        flexDirection: "column",
      }}
      id={props.popoverId}
      onClick={props.onClick}
    >
      {/* {userDetails.id && userDetails.name.length
                ? userDetails.name[0]
                : "G"} */}
      {<IonIcon icon={menuSharp} />}
      {/* {!props?.styleId && (
        <img
          src="assets/menu.png"
          alt=""
          style={{ height: "100%", width: "100%", objectFit: "contain" }}
        />
      )} */}
    </div>
  );
};

/*******************************************************************************
 * Component Name: BussinessHomeHeader
 * Description:
 *******************************************************************************/
const BussinessHomeHeader: React.FC<{
  logoImg: string;
  logoImgData: string;
  name: string;
  bussinessDetailsDB: BusinessDetailsType;
  onMenuClick: () => void;
  onSearchClick: () => void;
  styleData?: StyleDataType;
  hotKeys?: BhpHotKeysType[];
  clickHotKey?: (funcName: string) => void;
  categoryImgFileName?: string;
  editMode?: boolean;
  verifyMode?: boolean;
  nameVerified?: boolean;
  changeNameVerified?: (val: boolean) => void;
  openQR?: () => void;
}> = (props) => {
  const isMobile =
    useAppSelector((state) => state.screenWidth).width < mobileWidthBreakpoint;
  const { token, id } = getSessionDetails();
  const searchButtonJsx = (
    <div
      style={{
        width: "100%",
        padding: "5px 10px",
        height: "50px",
      }}
    >
      {/* {subHeaderJsx} */}
      <BhpSearchButton
        isMarket={props.bussinessDetailsDB.isMarket}
        onClick={() => {
          recordAction({
            action: userActionsTable.search,
            pageId: props.bussinessDetailsDB.id,
            pageSection: "MAIN",
            pageType: getPageType(
              props.bussinessDetailsDB.isMarket,
              props.bussinessDetailsDB.marketType
            ),
            notes: "Search Button",
          });
          props.onSearchClick();
        }}
        isRWA={props.bussinessDetailsDB?.marketType === "RWA"}
        styleData={props.styleData}
      />
    </div>
  );
  console.log("props =", props);
  const jsxSubheader = (
    <div
      style={{
        width: "100%",
        display: "flex",
        // display:
        //   bussinessDetailsDB.subscriptionType === "VCARD" ? "none" : "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      {searchButtonJsx}
    </div>
  );

  const catImgUrl = props?.categoryImgFileName
    ? `${IDIGIZEN_BACKEND_URL}/${getFileThumbnailDB}?fileName=${props.categoryImgFileName}&percentage=20&token=${token}&Authorization=${API_SECURE_KEY}`
    : "";

  const subHeader =
    !props.bussinessDetailsDB?.isMarket &&
    parseInt(props.bussinessDetailsDB.marketId) !== 1
      ? `${props.bussinessDetailsDB?.marketName}`
      : props.bussinessDetailsDB?.tagline;

  // useEffect(() => {
  //   // Dynamically change the title text
  //   if (props.name && props.name.toLowerCase() !== "vypzee") {
  //     //Re-target the title to the incoming title or to the market name
  //     let title = props.bussinessDetailsDB.seoUrlDetails?.title
  //       ? props.bussinessDetailsDB.seoUrlDetails?.title
  //       : `Explore ${props.name} & find latest offers - VypZee`;

  //     document.title = title;
  //   }

  //   if (!!props.logoImg) {
  //     // Dynamically change the shortcut icon
  //     const link =
  //       (document.querySelector("link[rel*='icon']") as HTMLLinkElement) ||
  //       document.createElement("link");
  //     link.type = "image/x-icon";
  //     link.rel = "shortcut icon";
  //     link.href = `${IDIGIZEN_BACKEND_URL}/${getFileThumbnailDB}?fileName=${props.logoImg}&percentage=10&token=${token}&Authorization=${API_SECURE_KEY}`;
  //     document.getElementsByTagName("head")[0].appendChild(link);
  //   }
  // }, [props.name, props.logoImg]);

  const recordAction = useRecordUserInteractions();

  const hotKeysImpJsx = (
    <IonGrid className="bhp-header-hotkey-grid">
      <IonRow>
        {props.hotKeys.map((item, idx) => {
          return (
            <>
              {item?.anchorTag && item.anchorTag ? (
                <IonCol size={`${12 / props.hotKeys.length}`} key={idx}>
                  <a href={item.anchorTag} className="bhp-a-tag-no-style">
                    <BhpCategoryCard
                      smallIcon={props.styleData.headerStyle === "CARD_ICON"}
                      imgFile={item.imgFileName}
                      name={item.name}
                      // horizontalMode={true}
                      iconMode={true}
                      onClick={() => {
                        props.clickHotKey(item.functionName);
                      }}
                    />
                  </a>
                </IonCol>
              ) : (
                <IonCol size={`${12 / props.hotKeys.length}`} key={idx}>
                  <BhpCategoryCard
                    smallIcon={props.styleData.headerStyle === "CARD_ICON"}
                    imgFile={item.imgFileName}
                    name={item.name}
                    // horizontalMode={true}
                    iconMode={true}
                    onClick={() => {
                      props.clickHotKey(item.functionName);
                    }}
                  />
                </IonCol>
              )}
            </>
          );
        })}
      </IonRow>
    </IonGrid>
  );
  const hotKeysJsx = (
    <div className="bhp-category-card-container bhp-hotkeys-bg">
      {hotKeysImpJsx}
    </div>
  );

  const goldThemeHeaderJsx = (
    <>
      <div
        style={{
          display: "flex",
          padding: "15px 0",
          paddingLeft: "10px",
          alignItems: "center",
        }}
      >
        <BhpMenuButton
          popoverId={`popover-button-${props.bussinessDetailsDB.id}-${props.bussinessDetailsDB.isMarket}`}
          onClick={props.onMenuClick}
          styleData={props.styleData}
        />
        <div style={{ flexGrow: "1" }}>{jsxSubheader}</div>
      </div>
      <div
        style={{
          height: "5px",
          position: "absolute",
          bottom: "-2px",
          left: "0",
          width: "100vw",
          background: "#fbf3e3",
          zIndex: "1000000000",
        }}
      ></div>
    </>
  );

  // const headerBg =
  //   "linear-gradient(to left, #434343 0%, var(--ion-color-bhp-footer) 100%)";

  // const subheaderBg = "var(--ion-color-bhp-hdr-dark)";
  const history = useHistory();

  const headerJsx = (
    <>
      <div
        style={{
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
        }}
      >
        <div
          style={{
            padding: "15px",
            paddingBottom: "2px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            // paddingBottom: "5px",
            // borderBottom: "1px solid lightgray",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
              paddingRight: "10px",
            }}
          >
            {/* <div
              style={{
                height: "40px",
                width: "40px",
                borderRadius: "50%",
                border: `2px solid ${props.styleData.headerFontColor}`,
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                overflow: "hidden",
                flexShrink: 0,
              }}
              onClick={props.onMenuClick}
            >
              <img
                style={{ height: "100%", width: "100%", objectFit: "cover" }}
                src={
                  !!props.logoImgData
                    ? props.logoImgData
                    : // : !!catImgUrl
                      // ? catImgUrl
                      getLogo(true)
                }
                alt=""
                loading="lazy"
              />
            </div> */}
            <div
              style={{
                paddingLeft: "10px",
                color: props.styleData.headerBaseColorHighlight,
                fontFamily:
                  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif",
              }}
            >
              <h1
                style={{
                  fontSize: "1.3rem",
                  fontWeight: "bold",
                  padding: "0",
                  margin: 0,
                  // color: "var(--ion-color-bhp-vypzee-dark)",
                  color: "var(--ion-color-bhp-hdr-dark)",
                }}
                onClick={() => {
                  if (!props.verifyMode) return;
                  props.changeNameVerified(!props.nameVerified);
                }}
              >
                {!!props.verifyMode && (
                  <span>
                    <IonIcon
                      icon={props?.nameVerified ? checkmarkCircle : ellipse}
                      color={props?.nameVerified ? "primary" : "medium"}
                    />
                  </span>
                )}
                {props.bussinessDetailsDB.name}
              </h1>
              <div>
                {props.bussinessDetailsDB.isMarket &&
                  props.bussinessDetailsDB.marketType === "MARKET" && (
                    <div>{`${props.bussinessDetailsDB?.address}`}</div>
                  )}
              </div>
              {!!subHeader && (
                <h2
                  style={{
                    color: "var(--ion-color-bhp-hdr-dark)",
                    fontSize: "0.6rem",
                    margin: 0,
                  }}
                >
                  {subHeader}
                </h2>
              )}
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                height: "30px",
                width: "30px",
                marginRight: "10px",
                fontSize: "18px",
                color: props?.styleData.headerBaseColorHighlight,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={() => {
                props.openQR();
              }}
            >
              <IonIcon icon={qrCodeOutline} />
            </div>
            <BhpMenuButton
              popoverId={`popover-button-${props.bussinessDetailsDB.id}-${props.bussinessDetailsDB.isMarket}`}
              onClick={props.onMenuClick}
              styleData={props.styleData}
            />
          </div>
        </div>
        <div
          style={{
            padding: "10px",
            // borderBottom: "1px solid var(--ion-color-bhp-gray)",
            paddingBottom: "45px",
            paddingTop: "5px",
          }}
        >
          {searchButtonJsx}
        </div>
        <div
          style={{
            paddingBottom: "5px",
            position: "absolute",
            bottom: "-40px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "95%",
              background: "var(--ion-color-bhp-hdr-dark)",
              padding: "0 10px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              borderRadius: "10px",
              paddingBottom: "5px",
            }}
          >
            {hotKeysImpJsx}
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      <div
        className={`bhp-header-top ${
          !props?.styleData.headerBg ? "bhp-header-top-normal" : ""
        }`}
        style={{
          background: !!props.styleData.headerBg
            ? props.styleData.headerBg
            : undefined,
        }}
      >
        {props?.styleData.headerStyle === "CIRCLE_ICON" && goldThemeHeaderJsx}
        {props?.styleData.headerStyle === "CARD_ICON" && headerJsx}
      </div>
      {props?.styleData.headerStyle === "CIRCLE_ICON" &&
        props.hotKeys?.length &&
        hotKeysJsx}
      {props?.styleData.headerStyle === "CARD_ICON" && props.hotKeys?.length ? (
        <div style={{ height: "40px" }}></div>
      ) : (
        <> </>
      )}
    </>
  );
};

export default BussinessHomeHeader;
export { BhpMenuButton, BhpSearchIconButton };
